import PasswordRulesList from './PasswordRulesList';

export default PasswordRulesList;
